
<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button color="warning" class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <page-title :title="`Welcome <br/> to ${$filters.appName()}`" subtitle="Please select user type" showIcon />

            <div class="buttons_wrapper">
                <!-- <el-button :class="{ active: type === 'job-seeker' }" type="transparent" @click="selectAuthType('job-seeker')">
                    Job Seeker
                    <span v-if="type === 'job-seeker'" class="checkmark"><svg width="20" height="20" viewBox="0 0 20 20"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                                fill="white" />
                        </svg>
                    </span>
                </el-button> -->
                <el-button :class="{ active: type === 'time-work' }" type="transparent" @click="selectAuthType('time-work')">
                    Full-Time (FT) / Part-Time (PT)
                    <span v-if="type === 'time-work'" class="checkmark"><svg width="20" height="20" viewBox="0 0 20 20"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                                fill="white" />
                        </svg>
                    </span>
                </el-button>
                <el-button :class="{ active: type === 'shift-work' }" type="transparent"
                    @click="selectAuthType('shift-work')">
                    Shift Work (inc FT/PT)
                    <span v-if="type === 'shift-work'" class="checkmark"><svg width="20" height="20" viewBox="0 0 20 20"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9.0026 14L16.0737 6.92893L14.6595 5.51472L9.0026 11.1716L6.17421 8.3431L4.75999 9.7574L9.0026 14Z"
                                fill="white" />
                        </svg>
                    </span>
                </el-button>
                <el-button class="submit" :disabled="type == ''" type="blue" @click="goNext()">
                    Continue
                </el-button>
            </div>
        </div>

        <div class="background-circles">
            <div class="circle circle-2"></div>
            <div class="circle circle-1"></div>
            <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/PageTitle/PageTitle.vue';
import {
    onMounted,
    onUnmounted,
    ref,
} from 'vue';
import store from "@/store/store";
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
} from 'vue-router'
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        PageTitle,
        SvgIcon
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const userWorkType = store.getters.GET_USER_WORK_TYPE;
        const type = ref(userWorkType ? userWorkType : '');

        const selectAuthType = (selectedType) => {
            type.value = selectedType;

        }
        const goBack = () => {
            $router.push({
                name: "locum_i_am",
            });
        }

        const goNext = () => {
            $store.dispatch('SET_USER_WORK_TYPE', type.value);
            if (type.value === 'time-work') {
                $store.dispatch('SET_USER_ROLE', "job-seeker");
                $router.push({
                    name: 'auth_password',
                    params: {
                        authType: 'register'
                    }
                })
            } else {
                $store.dispatch('SET_USER_ROLE', "locum");
                $router.push({
                    name: 'auth_password',
                    params: {
                        authType: 'register'
                    }
                })
            }
        };

        onMounted(() => {
            $('body').addClass('background_blue');
        });

        onUnmounted(() => {
            $('body').removeClass('background_blue');
        });
        return {
            selectAuthType,
            goBack,
            goNext,
            type
        }
    }
}
</script>
